import { OrderAssignment } from 'src/entities/orderEntity';
import {
  PlanningsDeliveryEntity,
  PlanningsDeliveryWithLegRunEntity,
  PlanningsLegRunOperationEntity,
} from 'src/entities/PlanningsDelivery.entity';
import { PlanningsOperationEntity } from 'src/entities/PlanningsOperation.entity';
import { ShipmentOrderLegRunEntity, ShipmentOrderLegRunForPlanEntity } from 'src/entities/ShipmentOrderLegRun.entity';

export const convertShipmentOrderLegRunEntitiesToDeliveries = (
  legRunEntities: PlanningsDeliveryWithLegRunEntity[],
  shipmentOrderLegRunEntityMap: Map<number, ShipmentOrderLegRunForPlanEntity> | null
): PlanningsDeliveryEntity[] => {
  if (!legRunEntities || legRunEntities.length === 0) return [];
  if (!shipmentOrderLegRunEntityMap) return [];

  const convertOperations = (ops: PlanningsLegRunOperationEntity[], legRuns: ShipmentOrderLegRunForPlanEntity[]) => {
    const ret: PlanningsOperationEntity[] = [];
    ops.forEach((it) => {
      // TODO: shipmentOrderLegRunEntityMap は不要になるはず。テストが必要。
      const legRunEntity = shipmentOrderLegRunEntityMap.get(it.shipmentOrderLegRunId) || legRuns.find((legRun) => legRun.id === it.shipmentOrderLegRunId);
      if (!legRunEntity) return;

      const items = legRunEntity.items;
      const itemTotalVolumeMm3 = items.filter((it) => it.volume_mm3).map((item) => item.volume_mm3).reduce((prev, current) => prev + current, 0);
      const itemTotalWeightForCalculation = items.filter((item) => item.weight_g).map((item) => item.weight_g).reduce((prev, current) => prev + current, 0);
      ret.push({
        id: it.id,
        shipperName: legRunEntity.shipper_name || '',
        itemName: items.map((item) => item.name).join(', '),
        itemCount: items.map((item) => item.quantity).reduce((prev, current) => prev + current, 0),
        itemTotalVolumeMm3,
        itemTotalWeightForCalculation,
        loadingName: legRunEntity.loading_name || '',
        loadingAddress: legRunEntity.loading_address || '',
        unloadingName: legRunEntity.unloading_name || '',
        unloadingAddress: legRunEntity.unloading_address || '',
        shiftTruckId: it.shiftTruckId,
        orderId: it.shipmentOrderLegRunId,
        arrivalAt: it.arrivalAt,
        departureAt: it.departureAt,
        drivingDurationSeconds: it.drivingDurationSeconds,
        nullDurationSeconds: it.nullDurationSeconds,
        operationDurationSeconds: it.operationDurationSeconds,
        operationStartAt: it.operationStartAt,
        waitingDurationSeconds: it.waitingDurationSeconds,
        drivingDistanceMm: it.drivingDistanceMm,
        action: it.action,
        minLoadingStartAt: legRunEntity.loading_start_at || '',
        maxLoadingEndAt: legRunEntity.loading_end_at || '',
        minUnloadingStartAt: legRunEntity.unloading_start_at || '',
        maxUnloadingEndAt: legRunEntity.unloading_end_at || '',
        operationWeightG: itemTotalWeightForCalculation * (it.action === '積' ?  1 : -1),
        operationVolumeMm3: itemTotalVolumeMm3 * (it.action === '積' ?  1 : -1),
        latitude: String(it.action === '積' ? legRunEntity.loading_lat : legRunEntity.unloading_lat),
        longitude: String(it.action === '積' ? legRunEntity.loading_lng : legRunEntity.unloading_lng),
        fixed: it.fixed,
        orderOperationStatus: it.orderOperationStatus,
        isChanged: false,
        originalShiftTruckIds: [],
        expandMaxVolumeRate: it.expandMaxVolumeRate,
        expandMaxLoadCapacityRate: it.expandMaxLoadCapacityRate,
        expandLoadStartTime: it.expandLoadStartTime,
        expandLoadEndTime: it.expandLoadEndTime,
        expandUnloadStartTime: it.expandUnloadStartTime,
        expandUnloadEndTime: it.expandUnloadEndTime,
        cycle: it.cycle,
        orderWasSplit: it.orderWasSplit,
        orderNormalizedAddress: it.orderNormalizedAddress,
        detail: it.detail,
        driverId: null,
        truckId: null,
        previousChanged: false,
      })
    });
    return ret;
  };

  const convertAssignments = (assignments: ShipmentOrderLegRunEntity[]) => {
    const ret: OrderAssignment[] = [];
    assignments.forEach((it) => {
      ret.push({
        id: it.id,
        order_id: it.shipment_order_leg_id,
        assignment: it.assignment,
        use_ltl: it.use_ltl,
        truck_number: it.truck_number,
        driver_name: it.driver_name,
        carrier_company: it.carrier_company,
        operationg_carrier: it.operating_carrier,
        hierarchey_level: it.hierarchy_level,
        delivery_id: it.delivery_id,
        planning_license_id: it.planning_license_id,
        planning_license_name: it.planning_license_name,
        selected_order_ids: [],
      })
    });
    return ret;
  };

  const entities: PlanningsDeliveryEntity[] = [];
  legRunEntities.forEach((it) => {
    entities.push({
      id: it.id,
      shiftId: it.shiftId,
      truckId: it.truckId,
      startAt: it.startAt,
      endAt: it.endAt,
      driverId: it.driverId,
      workStartAt: it.workStartAt,
      workEndAt: it.workEndAt,
      fixed: it.fixed,
      operations: convertOperations(it.operations, it.shipmentOrderLegRuns),
      arrivalDistanceMm: it.arrivalDistanceMm,
      garageLatitude: it.garageLatitude,
      garageLongitude: it.garageLongitude,
      driverColor: it.driverColor,
      distanceMmBurdenPerShippers: it.distanceMmBurdenPerShippers,
      arrivalOperation: it.arrivalOperation,
      departureOperation: it.departureOperation,
      workingAvailableDurationSeconds: it.workingAvailableDurationSeconds,
      orderAssignments: convertAssignments(it.assignments || []),
      continuousDeliveryIds: it.continuousDeliveryIds,
      workingSeconds: it.workingSeconds,
      returnToBase: it.returnToBase,
      continuousShiftGroupId: it.continuousShiftGroupId,
      continuousShiftStartAt: it.continuousShiftStartAt,
      continuousShiftEndAt: it.continuousShiftEndAt,
      legRunEntity: it,
    });
  });
  return entities;
};